export default __webpack_public_path__ + "static/media/icon_profile.b878c50d.svg";